import React from 'react';
import ContentCourseFailureAttemptRateSummaryContainer from './course/ContentCourseFailureAttemptRateSummaryContainer';
import ContentCourseErrorRateSummaryContainer from './course/ContentCourseErrorRateSummaryContainer';
import ContentCourseRepeatRateSummaryContainer from './course/ContentCourseRepeatRateSummaryContainer';
import ContentCourseSpeechRateSummaryContainer from './course/ContentCourseSpeechRateSummaryContainer';

const ContentCourseDetailSummary = () => (
  <div style={{ display: 'flex', justifyContent: 'space-around' }}>
    <ContentCourseFailureAttemptRateSummaryContainer />
    <ContentCourseRepeatRateSummaryContainer />
    <ContentCourseSpeechRateSummaryContainer />
    <ContentCourseErrorRateSummaryContainer />
  </div>
);

export default ContentCourseDetailSummary;
